import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../../common/services/permission';
import { Subscription } from 'rxjs';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { GlobalState } from '../../global.state';

@Injectable({ providedIn: 'root' })
export class LoginService {
  private _subscriptions: Array<Subscription> = [];
  private apiUrl: string = '';
  UsersObj: any;
  sendMail = true;
  securityCode = true;
  newPassword = true;
  searchUser = true;
  loginpage = true;
  email: any;
  constructor(
    private http: HttpClient,
    private gblstate: GlobalState,
    private authSerice: AuthService
  ) {}

  ngOnInit() {}
  userProfile!: Subject<any>;
  mockLogin(username: string, password: string) {}
  login(username: string, password: string) {
    let arr = this.gblstate.getGlobalSetting('apiUrl');
    if (arr) {
      this.apiUrl = arr[0];
    }
    console.log(this.apiUrl);
    //  console.log({ username: username, password: password });
    let header = new Headers({ 'content-type': 'application/json' });
    // let option = new RequestOptions({ headers: header });
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: '',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      }),
      withCredentials: true,
    };
    return this.http
      .post(
        this.apiUrl + '/jwt',
        { UserId: username, password: password },
        httpOptions
      )
      .pipe(
        map((response: any) => {
          // login successful if there's a jwt token in the response
          let user = response;
          if (user && user.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            console.log({ logginuser: user });
            this.authSerice.setAuth(user);

            //   console.log("checkUserServc",user);
            this.gblstate.setGlobalSetting('LoggedIn', [true]);
            //  console.log(this.gblstate.getGlobalSetting("LoggedIn"))
            this.gblstate.setGlobalSetting('userName', [username]);
            this.gblstate.setGlobalSetting('View-Permission', [
              'Divisions',
              'smartTables',
              'addDivision',
            ]);
            //   console.log(this.gblstate.getGlobalSetting("View-Permission"))

            this.authSerice.setSessionVariable(
              'LastProductChangeDateLocal',
              new Date('1990-01-01T00:00:00')
            );
          }
        })
      );
  }

  logout() {
    // remove user from local storage to log user out
    let arr = this.gblstate.getGlobalSetting('apiUrl');
    if (arr) {
      this.apiUrl = arr[0];
    }
    let reqOptions = this.authSerice.getRequestOption();
    let sub = this.http.get(this.apiUrl + '/logout', reqOptions).subscribe(
      (res: any) => {
        let data = res;
        if (data.status == 'ok') {
          //this.router.navigate(['login']);
        }
      },
      (error: any) => {
        console.log({ logoutError: error });
      }
    );
    this._subscriptions.push(sub);
    this.authSerice.removeAuth();
    window.sessionStorage.removeItem('currentUser');
    this.gblstate.notifyDataChanged('LoggedIn', false);
    this.gblstate.setGlobalSetting('LoggedIn', [false]);
    this.gblstate.setGlobalSetting('userName', ['']);
    this.gblstate.setGlobalSetting('View-Permission', []);

    //this.cacheService.remove('currentUser');
  }

  ngOnDestroy() {
    this._subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  ForgetPwd(username: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let arr = this.gblstate.getGlobalSetting('apiUrl');
    if (arr) {
      this.apiUrl = arr[0];
    }
    console.log(this.apiUrl);
    console.log({ username: username });
    // let header = new Headers({ 'content-type': 'application/json' });
    // let option = new RequestOptions({ headers: header });
    this.http
      .post(
        this.apiUrl + '/jwtForget',
        { username: username },
        this.authSerice.getRequestOption()
      )
      .subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
    return returnSubject;
  }
  sendEmail(Email: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let arr = this.gblstate.getGlobalSetting('apiUrl');
    if (arr) {
      this.apiUrl = arr[0];
    }
    console.log(this.apiUrl);
    console.log({ username: Email });
    // let header = new Headers({ 'content-type': 'application/json' });
    // let option = new RequestOptions({ headers: header });
    this.http
      .post(
        this.apiUrl + '/SendEmail',
        { username: Email },
        this.authSerice.getRequestOption()
      )
      .subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
    return returnSubject;
  }
  emailCode(RandomNumber: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let arr = this.gblstate.getGlobalSetting('apiUrl');
    if (arr) {
      this.apiUrl = arr[0];
    }
    console.log(this.apiUrl);
    console.log({ RandomNumber: RandomNumber });
    // let header = new Headers({ 'content-type': 'application/json' });
    // let option = new RequestOptions({ headers: header });
    this.http
      .post(
        this.apiUrl + '/emailno',
        { RandomNumber: RandomNumber },
        this.authSerice.getRequestOption()
      )
      .subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
    return returnSubject;
  }
  updatePassword(password: string, username: string) {
    let res = { status: 'error', result: '' };
    let returnSubject: Subject<any> = new Subject();
    let arr = this.gblstate.getGlobalSetting('apiUrl');
    if (arr) {
      this.apiUrl = arr[0];
    }
    console.log(this.apiUrl);
    console.log({ password: password });
    // let header = new Headers({ 'content-type': 'application/json' });
    // let option = new RequestOptions({ headers: header });
    this.http
      .post(
        this.apiUrl + '/updatePassword',
        { password: password, username: username },
        this.authSerice.getRequestOption()
      )
      .subscribe(
        (response: any) => {
          let data = response;
          if (data.status == 'ok') {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          } else {
            returnSubject.next(data);
            returnSubject.unsubscribe();
          }
        },
        (error: any) => {
          res.status = 'error';
          res.result = error;
          returnSubject.next(res);
          returnSubject.unsubscribe();
        }
      );
    return returnSubject;
  }
}
